import React from 'react'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import DropDownOA from '../../../../common/dropDownOA'
import { getURRSpecialRightsLeftData, getApprAuthority, getURRSpecialRightsCheckBoxList, getFBUserModifyData, getFareChngBookPageData, getAllowCancelChrgData, getAllowRSTTData, getDisableChartTransferData } from '../../constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import { getFloat, getSignedFloat, navigation3 } from '../../../../common/helper'
import { Stack } from '@mui/system'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import InfoIcon from '@mui/icons-material/Info'
import LineinputV2 from '../../../../common/lineinputV2'
import { userRRSpecialRightsSave } from '../../../../../store/branchAndUserMaster/BUMAction'
import OTPModal from '../OTPModal'
import SuccessfullModal from '../../../../common/SuccessfullModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { oTPForUserRoleRight } from '../../../../common/jotaiState/commonStateAtoms'
const SpecialRights = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const URRSpecialRightsLeftData = getURRSpecialRightsLeftData(translations)
    const ApprAuthority = getApprAuthority(translations)
    const URRSpecialRightsCheckBoxList = getURRSpecialRightsCheckBoxList(translations)
    const FBUserModifyData = getFBUserModifyData(translations)
    const fareChngBookPageData = getFareChngBookPageData(translations)
    const allowCancelChrgData = getAllowCancelChrgData(translations)
    const allowRSTTData = getAllowRSTTData(translations)
    const DisableChartTransferData = getDisableChartTransferData(translations)
    const { data, updateModal, userRRSpecialRightsSave, specialRightsLeftValues, setSpecialRightsLeftValues, specialRightsMiddValues, setSpecialRightsMiddValues, specialRightsThirdValues, setSpecialRightsThirdValues, roleId, otpOnUserRights, loginData } = props
    const { updateAlertError } = props
    const { common } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [selApprAuth, setSelApprAuth] = useState("")
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })

    const handleChange = (value, field) => {
        setSpecialRightsLeftValues(prevState => ({
            ...prevState,
            [field]: { ...prevState[field], value: value }
        }));
    }
    const handleCheckBox = (value, field) => {
        setSpecialRightsLeftValues(prevState => ({
            ...prevState,
            [field]: { ...prevState[field], check: value }
        }));
    }
    const handleDropDown = (value, field) => {
        setSpecialRightsLeftValues(prevState => ({
            ...prevState,
            [field]: { ...prevState[field], value: value }
        }));
    }
    const handleChangeThirdCheck = (value, field) => {
        setSpecialRightsThirdValues(prevState => ({
            ...prevState,
            [field]: value
        }));
    }


    const saveApi = () => {
        const { allowReprintSTTicket, allowReprintCTTicket, allowBookAfterMin, allowBookCancelrMin, allowBackDateBook, allowBackDateCancel, allowBackDateSelection, allowMaxSeatBook, allowBusShedule, allowBusPayment, allowStopBook, allowNoOfPhoneBook } = specialRightsLeftValues
        const { allowFBUserOFFBook, allowNonReportBkgPage, allowFareChgonBook, allowLimitFareChrg, allowCancelChrg, allowCancelChrgBeet, allowDisableChart, allowDisableChartAD, couponRights, openTicketPer, AllowVewAllBranchReport, AllowCanAnyBrnchAnyUser, AllowChartBlockUnBlock, AllowCanPhoneMinAfterBook } = specialRightsMiddValues
        const obj = {
            RoleID: roleId,
            AllowReprintSeatTransferOwnBranch: allowReprintSTTicket?.value?.id == -1 ? 1 : allowReprintSTTicket?.value?.id == 1 ? 1 : 0,
            AllowReprintSeatTransferOthBranch: allowReprintSTTicket?.value?.id == -1 ? 1 : allowReprintSTTicket?.value?.id == 2 ? 1 : 0,
            AllowReprintChartTransferOwnBranch: allowReprintCTTicket?.value?.id == -1 ? 1 : allowReprintCTTicket?.value?.id == 1 ? 1 : 0,
            AllowReprintChartTransferOthBranch: allowReprintCTTicket?.value?.id == -1 ? 1 : allowReprintCTTicket?.value?.id == 2 ? 1 : 0,
            AllowBookingAfterMin: allowBookAfterMin?.check,
            AllowBkgAfterMins: allowBookAfterMin?.value,
            AllowCancelBeforeMin: allowBookCancelrMin?.check,
            AllowCancBeforeMin: allowBookCancelrMin?.value && allowBookCancelrMin.value !== '-' ? Number(allowBookCancelrMin.value) : 0,
            AllowBackDateBooking: allowBackDateBook?.check,
            BackDateBookingAllowedForNoOfDays: allowBackDateBook?.value,
            AllowBackDateCancellation: allowBackDateCancel?.check,
            BackDateCancelAllowedForNoOfDays: allowBackDateCancel?.value,
            DisableBackdate: allowBackDateSelection?.check,
            NoOfBackdateSelection: allowBackDateSelection?.value,
            AllowTotalSeatsBkg: allowMaxSeatBook?.value?.id,
            AllowBusSchedule: allowBusShedule?.value?.id,
            AllowBusPayments: allowBusPayment?.value?.id,
            AllowStopBooking: allowStopBook?.value?.id,
            PhonebookingCount: allowNoOfPhoneBook?.value?.id,
            AllowNonReportOnBookingPageOwnBranch: allowNonReportBkgPage?.value?.id == -1 ? 1 : allowNonReportBkgPage?.value?.id == 1 ? 1 : 0,
            AllowNonReportOnBookingPageOthBranch: allowNonReportBkgPage?.value?.id == -1 ? 1 : allowNonReportBkgPage?.value?.id == 2 ? 1 : 0,
            NonReportAfterHrs: Number(allowNonReportBkgPage?.inp),
            AllowFareChange: allowFareChgonBook?.value?.id,
            LimitOnFareChange: allowLimitFareChrg?.inp1,
            LimitOnFareChangePer: allowLimitFareChrg?.inp2,
            AllowCancelChargeChange: allowCancelChrg?.value?.id,
            CancelChargePctFrom: allowCancelChrgBeet?.inp1,
            CancelChargePctTo: allowCancelChrgBeet?.inp2,
            DisableChartTransferAdavnce: allowDisableChart?.value?.id == 3 ? 1 : 0,
            DisableChartTransferOnSameDay: allowDisableChart?.value?.id == 2 ? 1 : 0,
            DisableChartTransferAfterDeptMin: allowDisableChart?.value?.id == 1 ? 1 : 0,
            DisableChartTransferAfterDeptMins: Number(allowDisableChartAD?.value),
            AllowOpenTicket: couponRights?.check1,
            AllowPartialRefundTicket: couponRights?.check2,
            AllowPrepaidCard: couponRights?.check3,
            opentktper: openTicketPer?.value,
            AllowViewAllBranchReport: AllowVewAllBranchReport,
            AllowCancelAllBranch: AllowCanAnyBrnchAnyUser,
            AllowChartBlockUnblock: AllowChartBlockUnBlock,
            AllowCancelPhoneBookingAfterMin: AllowCanPhoneMinAfterBook,
            AllowArrTransfer: specialRightsThirdValues?.AllowArrangeMentTrans,
            AllowInspection: specialRightsThirdValues?.AllowInspaction,
            EnableCancelChartRightsForUser: specialRightsThirdValues?.AllowCancelChartRightForUser,
            AllowBoarded: specialRightsThirdValues?.AllowBoarded,
            AllowUnBoarded: specialRightsThirdValues?.AllowUnBoarded,
            AllowPNRInValidate: specialRightsThirdValues?.AllowPNRInvalidate,
            AllowVM: specialRightsThirdValues?.AllowVehicleMaintenance,
            ChangePaymentMode: specialRightsThirdValues?.ChangePayMode,
            AllowPkpDrpChange: specialRightsThirdValues?.AllowPkpDropChange,
            AllowAddQuota: specialRightsThirdValues?.AllowCheckQuota,
            AllowRemoveQuota: specialRightsThirdValues?.AllowRemoveQuota,
            AllowPrepaidAgentBooking: specialRightsThirdValues?.AllowPrePaidAgentsBook,
            AllowNetRateAgentCommission: specialRightsThirdValues?.AllowNetRatePayOut,
            AllowFullRefund: specialRightsThirdValues?.AllowFullRefundOther,
            AllowFullRefundAgentTicket: specialRightsThirdValues?.AllowFullRefundAgent,
            AllowVoucherDeletion: specialRightsThirdValues?.AllowVoucherDeletion,
            AllowVoucherWriteOff: specialRightsThirdValues?.AllowVoucherWriteOff,
            intAllowVoucherDeletionFrBr: specialRightsThirdValues?.AllowVoucherDeletionFrBr,
            intAllowVoucherWriteOffFrBr: specialRightsThirdValues?.AllowVoucherWriteOffFrBr,
            AllowRefundAgentTicket: specialRightsThirdValues?.AllowRefundAgentTicket,
            AllowSeatWisePricing: specialRightsThirdValues?.AllowSeatWisePricing,
            AllowSeatLockUnlock: specialRightsThirdValues?.AllowSeatLockUnLock,
            AllowOnlineVoucher: specialRightsThirdValues?.AllowGenOnliAgentVoucher,
            AllowVoucherNetActualAmtChange: specialRightsThirdValues?.AllowVoucherNetActAmt,
            AllowVoucherActualAmtChange: specialRightsThirdValues?.AllowVoucherActAmt,
            AllowTransactionChange: specialRightsThirdValues?.AllowTransactionChange,
            AllowFinishedChartFareChange: specialRightsThirdValues?.AllowFinishChartFareChange,
            AllowModifyPhoneToConfirm: specialRightsThirdValues?.AllowModiPhoneToConfirm,
            UserID: loginData?.intUserID,
            BaseUserID: loginData?.intUserID,
            AllowAutoCancelMinsChange: specialRightsThirdValues?.AllowCanMinChange,
            AllowOnlineBkgModification: specialRightsThirdValues?.AllowOnBookModify,
            AllowFranchiseeUserOfflinetktMod: allowFBUserOFFBook?.value?.id == -1 ? 1 : allowFBUserOFFBook?.value?.id == 0 ? 1 : 0,
            FranchiseeUserOnlinetktMod: allowFBUserOFFBook?.value?.id == -1 ? 1 : allowFBUserOFFBook?.value?.id == 1 ? 1 : 0,
            AllowOnlineFRPR: specialRightsThirdValues?.AllowOnlineFRPR,
            AllowOnlineFRPRAPI: specialRightsThirdValues?.AllowOnlineFRPRAPI,
            IsAllowInterTripTran: specialRightsThirdValues?.IsAllowInterTripTran
        }
        userRRSpecialRightsSave(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen({ ...isOpen, open: true, message: bum.specialRightsSavedSuccessfullyNl || "Special Rights\nSaved Successfully!" })
            } else {
                setSaveError({ ...saveError, error: true, message: res.Message })
            }
        }).catch((err) => {
            setSaveError({ ...saveError, error: true, message: err })
        })
    }

    const sendOTPRequest = () => {
        const obj = {
            strOTPType: "UR",
            intCompanyId: loginData?.intCompanyID,
            intRoleID: roleId,
            intSaveType: 1,
            intOTPSendType: selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
        })
    }

    const onSave = () => {
        if (otpOnUserRights == 1) {
            if (selApprAuth === "") {
                updateAlertError({ show: true, msg: bum.selectApprovalAuthority || "Select Approval Authority", nextId: "UmAppAuth" })
            } else {
                sendOTPRequest()
            }
        } else {
            saveApi()
        }
    }

    return (
        <>
            <Box className="scrollBlue" sx={{ padding: "18px", paddingTop: "0px", overflowY: "scroll", height: "75vh" }}>
                <Box>
                    <Grid container spacing={2} sx={{ display: "flex", alignItems: "start" }}>
                        <Grid item md={4.3}>
                            {
                                URRSpecialRightsLeftData?.map((item, i) => {
                                    return (
                                        <Box className={`bookAccSpecialleft ${i > 5 ? "BranchAndUsrBottomSec" : ""}`} key={i}>
                                            <FormControlLabel
                                                key={i}
                                                value="end"
                                                control={<Checkbox id={item.id} checked={specialRightsLeftValues[item?.field]?.check === 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                                label={
                                                    <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                        {item.heading}
                                                    </Typography>
                                                }
                                                disabled={item?.disabled}
                                                onChange={(e) => {
                                                    handleCheckBox(e.target.checked ? 1 : 0, item.field)
                                                }}
                                                labelPlacement="end"
                                            />
                                            {
                                                item.IsDrop == 1 ?
                                                    <Item sx={sx.itemsx} style={{ width: "145px" }}>
                                                        <DropDownOA
                                                            id={"UMStatus"}
                                                            defaultvalue={specialRightsLeftValues[item?.field]?.value?.value || ""}
                                                            data={item.data || []}
                                                            width="100%"
                                                            listWidth={"150px"}
                                                            searchPlaceholder={cs.search || 'Search'}
                                                            label={item.label}
                                                            dataKey={`value`}
                                                            idKey={`id`}
                                                            nextId={"UMLoad"}
                                                            prevId={"UMCreateNewMaster"}
                                                            onSelect={(value) => handleDropDown(value, item.field)}
                                                        />
                                                    </Item>
                                                    :
                                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "145px" }}>
                                                        <LineinputV2
                                                            icon={"crossIcon"}
                                                            filter={item.field === "allowBookCancelrMin" ? getSignedFloat : getFloat}
                                                            label={item.label}
                                                            value={specialRightsLeftValues[item?.field]?.value}
                                                            type="text"
                                                            name="PAN"
                                                            sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                                            onBlur={(e) => handleChange(e.target.value, item?.field)}
                                                            resetCallback={() => handleChange("", item?.field)}
                                                        />
                                                    </Box>
                                            }
                                        </Box>
                                    )
                                })
                            }
                        </Grid>
                        <Grid item md={4.7}>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["allowFBUserOFFBook"]?.check == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowFbUserModifyOfflineBkg || 'Allow FB User Modify Offline Bkg.'}
                                        </Typography>
                                    }
                                    disabled={true}
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowFBUserOFFBook"]: { ...prevState["allowFBUserOFFBook"], check: e.target.checked ? 1 : 0, }
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                                <Item sx={sx.itemsx} style={{ width: "182px" }}>
                                    <DropDownOA
                                        id={"UMStatus"}
                                        defaultvalue={specialRightsMiddValues["allowFBUserOFFBook"]?.value?.value}
                                        data={FBUserModifyData || []}
                                        width="100%"
                                        listWidth={"180px"}
                                        searchPlaceholder={cs.search || 'Search'}
                                        label={""}
                                        dataKey={`value`}
                                        idKey={`id`}
                                        nextId={"UMLoad"}
                                        prevId={"UMCreateNewMaster"}
                                        onSelect={(value) => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowFBUserOFFBook"]: { ...prevState["allowFBUserOFFBook"], value: value }
                                        }))}
                                    />
                                </Item>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["allowNonReportBkgPage"]?.check == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowNonReportOnBkgPage || 'Allow Non-Report On Bkg. Page'}
                                        </Typography>
                                    }
                                    disabled={true}
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowNonReportBkgPage"]: { ...prevState["allowNonReportBkgPage"], check: e.target.checked ? 1 : 0, }
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                                <Box style={{ display: "flex", gap: "8px" }}>
                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "120px" }}>
                                        <Item sx={sx.itemsx} style={{ width: "120px" }}>
                                            <DropDownOA
                                                id={"UMStatus"}
                                                defaultvalue={specialRightsMiddValues["allowNonReportBkgPage"]?.value?.value}
                                                data={allowRSTTData || []}
                                                width="100%"
                                                listWidth={"150px"}
                                                searchPlaceholder={cs.search || 'Search'}
                                                label={""}
                                                dataKey={`value`}
                                                idKey={`id`}
                                                nextId={"UMLoad"}
                                                prevId={"UMCreateNewMaster"}
                                                onSelect={(value) => setSpecialRightsMiddValues(prevState => ({
                                                    ...prevState,
                                                    ["allowNonReportBkgPage"]: { ...prevState["allowNonReportBkgPage"], value: value }
                                                }))}
                                            />
                                        </Item>
                                    </Box>
                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "52px" }}>
                                        <LineinputV2
                                            filter={getFloat}
                                            label={bum.hrs || "Hrs"}
                                            value={specialRightsMiddValues["allowNonReportBkgPage"]?.inp}
                                            type="text"
                                            name="PAN"
                                            sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            onBlur={(e) => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowNonReportBkgPage"]: { ...prevState["allowNonReportBkgPage"], inp: e.target.value }
                                            }))}
                                            resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowNonReportBkgPage"]: { ...prevState["allowNonReportBkgPage"], inp: "" }
                                            }))}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["allowFareChgonBook"]?.check == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowFareChgOnBkgPage || 'Allow Fare Chg. On Bkg. Page'}
                                        </Typography>
                                    }
                                    disabled={true}
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowFareChgonBook"]: { ...prevState["allowFareChgonBook"], check: e.target.checked ? 1 : 0, }
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                                <Item sx={sx.itemsx} style={{ width: "182px" }}>
                                    <DropDownOA
                                        id={"UMStatus"}
                                        defaultvalue={specialRightsMiddValues["allowFareChgonBook"]?.value?.value}
                                        data={fareChngBookPageData || []}
                                        width="100%"
                                        listWidth={"180px"}
                                        searchPlaceholder={cs.search || 'Search'}
                                        label={""}
                                        dataKey={`value`}
                                        idKey={`id`}
                                        nextId={"UMLoad"}
                                        prevId={"UMCreateNewMaster"}
                                        onSelect={(value) => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowFareChgonBook"]: { ...prevState["allowFareChgonBook"], value: value },
                                            ["allowLimitFareChrg"]: { ...prevState["allowLimitFareChrg"], inp1: 0, inp2: 0 },
                                        }))}
                                    />
                                </Item>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={true} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    sx={{ ".Mui-checked": { visibility: "hidden" } }}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.limitOnFareChange || 'Limit On Fare Change'}
                                        </Typography>
                                    }
                                    labelPlacement="end"
                                />
                                <Box style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "77px" }}>
                                        <LineinputV2
                                            icon={"crossIcon"}
                                            filter={getFloat}
                                            label={bum.rs || "Rs"}
                                            disabled={specialRightsMiddValues["allowFareChgonBook"]?.value?.id == 0}
                                            value={specialRightsMiddValues["allowLimitFareChrg"]?.inp1}
                                            type="text"
                                            name="PAN"
                                            sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            onBlur={(e) => {
                                                if (e.target.value !== specialRightsMiddValues["allowLimitFareChrg"]?.inp1) {
                                                    setSpecialRightsMiddValues(prevState => ({
                                                        ...prevState,
                                                        ["allowLimitFareChrg"]: { ...prevState["allowLimitFareChrg"], inp1: e.target.value, inp2: 0 },
                                                    }))
                                                }
                                            }}
                                            resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowLimitFareChrg"]: { ...prevState["allowLimitFareChrg"], inp1: "" }
                                            }))}
                                        />
                                    </Box>
                                    <Box style={{ fontSize: "14px", fontWeight: "500" }}>{bum.or || 'Or'}</Box>
                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "77px" }}>
                                        <LineinputV2
                                            icon={"croson"}
                                            filter={getFloat}
                                            label={bum.percent || "%"}
                                            disabled={specialRightsMiddValues["allowFareChgonBook"]?.value?.id == 0}
                                            value={specialRightsMiddValues["allowLimitFareChrg"]?.inp2}
                                            type="text"
                                            name="PAN"
                                            sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            onBlur={(e) => {
                                                if (e.target.value !== specialRightsMiddValues["allowLimitFareChrg"]?.inp2) {
                                                    setSpecialRightsMiddValues(prevState => ({
                                                        ...prevState,
                                                        ["allowLimitFareChrg"]: { ...prevState["allowLimitFareChrg"], inp2: e.target.value, inp1: 0 },
                                                    }))
                                                }
                                            }}
                                            resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowLimitFareChrg"]: { ...prevState["allowLimitFareChrg"], inp2: "" }
                                            }))}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["allowCancelChrg"]?.check == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowCancelChargeChange || 'Allow Cancel Charge Change'}
                                        </Typography>
                                    }
                                    disabled={true}
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowCancelChrg"]: { ...prevState["allowCancelChrg"], check: e.target.checked ? 1 : 0, }
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                                <Item sx={sx.itemsx} style={{ width: "182px" }}>
                                    <DropDownOA
                                        id={"UMStatus"}
                                        defaultvalue={specialRightsMiddValues["allowCancelChrg"]?.value?.value}
                                        data={allowCancelChrgData || []}
                                        width="100%"
                                        listWidth={"150px"}
                                        searchPlaceholder={cs.search || 'Search'}
                                        label={""}
                                        dataKey={`value`}
                                        idKey={`id`}
                                        nextId={"UMLoad"}
                                        prevId={"UMCreateNewMaster"}
                                        onSelect={(value) => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowCancelChrg"]: { ...prevState["allowCancelChrg"], value: value },
                                            ["allowCancelChrgBeet"]: { ...prevState["allowCancelChrgBeet"], inp1: 0, inp2: 0 }
                                        }))}
                                    />
                                </Item>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={true} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    sx={{ ".Mui-checked": { visibility: "hidden" } }}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.cancelChargeChangeBetween || 'Cancel Charge Change Between'}
                                        </Typography>
                                    }
                                    labelPlacement="end"
                                />
                                <Box style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "77px" }}>
                                        <LineinputV2
                                            filter={getFloat}
                                            disabled={specialRightsMiddValues["allowCancelChrg"]?.value?.id == 0}
                                            label={bum.fromPercent || "From (%)"}
                                            value={specialRightsMiddValues["allowCancelChrgBeet"]?.inp1}
                                            type="text"
                                            name="PAN"
                                            sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            onBlur={(e) => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowCancelChrgBeet"]: { ...prevState["allowCancelChrgBeet"], inp1: e.target.value }
                                            }))}
                                            resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowCancelChrgBeet"]: { ...prevState["allowCancelChrgBeet"], inp1: "" }
                                            }))}
                                        />
                                    </Box>
                                    <Box style={{ fontSize: "14px", fontWeight: "500" }}>{bum.dash || '-'}</Box>
                                    <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "77px" }}>
                                        <LineinputV2
                                            filter={getFloat}
                                            disabled={specialRightsMiddValues["allowCancelChrg"]?.value?.id == 0}
                                            label={bum.toPercent || "To (%)"}
                                            value={specialRightsMiddValues["allowCancelChrgBeet"]?.inp2}
                                            type="text"
                                            name="PAN"
                                            sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            onBlur={(e) => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowCancelChrgBeet"]: { ...prevState["allowCancelChrgBeet"], inp2: e.target.value }
                                            }))}
                                            resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["allowCancelChrgBeet"]: { ...prevState["allowCancelChrgBeet"], inp2: "" }
                                            }))}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["allowDisableChart"]?.check == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.disableChartTransfer || 'Disable Chart Transfer'}
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowDisableChart"]: { ...prevState["allowDisableChart"], check: e.target.checked ? 1 : 0, }
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                                <Item sx={sx.itemsx} style={{ width: "182px" }}>
                                    <DropDownOA
                                        id={"UMStatus"}
                                        defaultvalue={specialRightsMiddValues["allowDisableChart"]?.value?.value}
                                        data={DisableChartTransferData || []}
                                        width="100%"
                                        listWidth={"200px"}
                                        searchPlaceholder={cs.search || 'Search'}
                                        label={""}
                                        dataKey={`value`}
                                        idKey={`id`}
                                        nextId={"UMLoad"}
                                        prevId={"UMCreateNewMaster"}
                                        onSelect={(value) => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowDisableChart"]: { ...prevState["allowDisableChart"], value: value },
                                            ["allowDisableChartAD"]: { ...prevState["allowDisableChartAD"], value: 0 }
                                        }))}
                                    />
                                </Item>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={true} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    sx={{ ".Mui-checked": { visibility: "hidden" } }}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.disableChartTransAfterDeparture || 'Disable Chart Trans. After Departure'}
                                        </Typography>
                                    }
                                    labelPlacement="end"
                                />
                                <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "182px" }}>
                                    <LineinputV2
                                        icon={"crossIcon"}
                                        filter={getFloat}
                                        label={bum.minutes || "Minutes"}
                                        disabled={specialRightsMiddValues["allowDisableChart"]?.value?.id !== 1}
                                        value={specialRightsMiddValues["allowDisableChartAD"]?.value}
                                        type="text"
                                        name="PAN"
                                        sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                        onBlur={(e) => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowDisableChartAD"]: { ...prevState["allowDisableChartAD"], value: e.target.value }
                                        }))}
                                        resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["allowDisableChartAD"]: { ...prevState["allowDisableChartAD"], value: "" }
                                        }))}
                                    />
                                </Box>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["couponRights"]?.check == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.couponRights || 'Coupon Rights'}
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["couponRights"]: { ...prevState["couponRights"], check: e.target.checked ? 1 : 0, }
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                                <Box>
                                    <FormControlLabel
                                        value="end"
                                        control={<Checkbox checked={specialRightsMiddValues["couponRights"]?.check1 == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                        sx={{ paddingX: "3px" }}
                                        label={
                                            <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                {bum.ot || 'OT'}
                                            </Typography>
                                        }
                                        onChange={(e) => {
                                            setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["couponRights"]: { ...prevState["couponRights"], check1: e.target.checked ? 1 : 0, }
                                            }));
                                        }}
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="end"
                                        control={<Checkbox checked={specialRightsMiddValues["couponRights"]?.check2 == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                        sx={{ paddingX: "3px" }}
                                        label={
                                            <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                {bum.dc || 'DC'}
                                            </Typography>
                                        }
                                        onChange={(e) => {
                                            setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["couponRights"]: { ...prevState["couponRights"], check2: e.target.checked ? 1 : 0, }
                                            }));
                                        }}
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="end"
                                        control={<Checkbox checked={specialRightsMiddValues["couponRights"]?.check3 == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                        sx={{ paddingX: "3px" }}
                                        label={
                                            <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                {bum.pc || 'PC'}
                                            </Typography>
                                        }
                                        onChange={(e) => {
                                            setSpecialRightsMiddValues(prevState => ({
                                                ...prevState,
                                                ["couponRights"]: { ...prevState["couponRights"], check3: e.target.checked ? 1 : 0, }
                                            }));
                                        }}
                                        labelPlacement="end"
                                    />
                                </Box>
                            </Box>
                            <Box className={`bookAccSpecialMid`}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={true} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    sx={{ ".Mui-checked": { visibility: "hidden" } }}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.openTicketPercentage || 'Open Ticket Percentage'}
                                        </Typography>
                                    }
                                    labelPlacement="end"
                                />
                                <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "182px" }}>
                                    <LineinputV2
                                        icon={"crossIcon"}
                                        filter={getFloat}
                                        label={bum.percentage || "Percentage"}
                                        value={specialRightsMiddValues["openTicketPer"]?.value}
                                        type="text"
                                        name="PAN"
                                        sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                        onBlur={(e) => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["openTicketPer"]: { ...prevState["openTicketPer"], value: e.target.value }
                                        }))}
                                        resetCallback={() => setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["openTicketPer"]: { ...prevState["openTicketPer"], value: "" }
                                        }))}
                                    />
                                </Box>
                            </Box>
                            <Box style={{ marginTop: "20px" }}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["AllowVewAllBranchReport"] == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowViewAllBranchReports || 'Allow View All Branch Reports'}
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["AllowVewAllBranchReport"]: e.target.checked ? 1 : 0,
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                            </Box>
                            <Box >
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["AllowCanAnyBrnchAnyUser"] == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowCancelAnyBranchAnyUser || 'Allow Cancel Any Branch Any User'}
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["AllowCanAnyBrnchAnyUser"]: e.target.checked ? 1 : 0,
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                            </Box>
                            <Box >
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["AllowChartBlockUnBlock"] == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowChartBlockUnblock || 'Allow Chart Block / Unblock'}
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["AllowChartBlockUnBlock"]: e.target.checked ? 1 : 0,
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                            </Box>
                            <Box >
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={specialRightsMiddValues["AllowCanPhoneMinAfterBook"] == 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                    label={
                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                            {bum.allowCancelPhoneMinAfterBooking || 'Allow Cancel Phone Min After Booking'}
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setSpecialRightsMiddValues(prevState => ({
                                            ...prevState,
                                            ["AllowCanPhoneMinAfterBook"]: e.target.checked ? 1 : 0,
                                        }));
                                    }}
                                    labelPlacement="end"
                                />
                            </Box>
                        </Grid>
                        <Grid item md={3}>
                            {URRSpecialRightsCheckBoxList.map((obj, i) =>
                                <Box style={{ marginTop: i == 0 ? "10px" : "" }}>
                                    <FormControlLabel
                                        key={i}
                                        value="end"
                                        control={<Checkbox id={obj.id} checked={specialRightsThirdValues[obj?.field] === 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                        onKeyDown={(e) => {
                                            navigation3(e, obj.nextId, obj.prevId, () => { })
                                        }}
                                        label={
                                            <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                {obj.label}
                                            </Typography>
                                        }
                                        onChange={(e) => {
                                            handleChangeThirdCheck(e.target.checked ? 1 : 0, obj.field)
                                        }}
                                        labelPlacement="end"
                                    />
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Stack style={{ position: 'sticky', bottom: 0, backgroundColor: "white" }} className="itemButtons beachTransBottomSec">
                <Divider />
                <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "16px", paddingBottom: "5px", gap: "12px" }}>
                    <Box style={{ display: "flex" }}>
                        <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
                            <DropDownOA
                                id={"UmAppAuth"}
                                data={ApprAuthority || []}
                                defaultvalue={selApprAuth?.name || ''}
                                width="100%"
                                searchPlaceholder={bum.searchBranchName || 'Search Branch Name'}
                                label={bum.approvalAuthority || "Approval Authority"}
                                dataKey={`name`}
                                idKey={`id`}
                                nextId={"UMActive"}
                                field={'compulsory'}
                                prevId={"UMPAN"}
                                onSelect={(value) => setSelApprAuth(value)}
                            />
                        </Item>
                        <Box style={{ marginLeft: "5px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
                            <InfoIcon style={{ color: "#0086FF" }} />
                            <span style={{ color: "#1E59A7" }}>{bum.otpWillSendToManagementAsPerSelection || 'OTP will send to the Management as per Selection'}</span>
                        </Box>
                    </Box>
                    <Box style={{ display: "flex", gap: "15px" }}>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMSave", "UMUserStatus", () => { })}>
                            <Button id={"UMCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => updateModal(false, "BookAccSpecialRights")}>
                                {bum.cancel || 'CANCEL'}
                            </Button>
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMUserName", "UMCancel", () => { })}>
                            <Button variant="contained" id="UMSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                                onClick={() => onSave()}
                            >
                                {bum.save || 'Save'}
                            </Button>
                        </Item>
                    </Box>
                </Box>
                {/* */}
            </Stack>
            {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, userRRSpecialRightsSave
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialRights)